<template>
    <div id="detalhesAtracoesArtisticas">
        <b-row class="mt-2">
            <h5 class="ml-3 w-100 titulo-mobile d-flex justify-content-between align-items-center">
                Atrações Artísticas
                <busca-tabela @busca="filtrarItens" />
            </h5>

            <b-table :fields="fields" :items="itens" :busy="tableBusy" :current-page="currentPage" hover
                no-border-collapse sort-by="" :sort-desc="true" stacked="sm" responsive show-empty>
                <template #empty>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                </template>
                <template #table-busy>
                    <div class="text-center text-dark">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="loading-text">Carregando...</strong>
                    </div>
                </template>
                <template v-slot:cell(detalhes)="row">
                    <b-link class="text-dark" @click="row.toggleDetails">
                        <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                    </b-link>
                </template>
                <template #row-details="row">
                    <b-card no-body>
                        <b-row class="mt-2">
                            <b-col><strong>Razão Social da Atração</strong><br/><span>{{row.item.NmFiscalAtracao }}</span></b-col>
                            <b-col><strong>Razão Social do Representante Legal</strong><br/><span>{{row.item.NmRazaoSocialRepresentante}}</span></b-col>
                            <b-col><strong>Valor Estimado</strong><br/><span>{{formatMoeda(row.item.VlAtracao)}}</span></b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col><strong>Data da Apresentação</strong><br/><span>{{formatDataHora(row.item.DtInicio)}}</span></b-col>
                            <b-col><strong>Duração da Apresentação</strong><br/><span>{{`${row.item.VlDuracaoMinutos} minutos`}}</span></b-col>
                            <b-col><strong>Previsão de término</strong><br/><span>{{formatDataHora(new Date(row.item.DtInicio.getTime() + row.item.VlDuracaoMinutos*60000))}}</span></b-col>
                        </b-row>
                        <b-row  class="mt-2">
                            <b-col><strong>CPF/CNPJ da Atração Artística</strong><br/><span>{{row.item.CdCpfCnpjAtracaoArtistica}}</span></b-col> 
                            <b-col><strong>CPF/CNPJ do Representante Legal</strong><br/><span>{{row.item.CdCpfCnpjRepresentanteLegal}}</span></b-col>
                            <b-col><strong>Atração Local</strong><br/><span>{{row.item.FlAtracaoLocal == "S" ? "Sim" : "Não" }}</span></b-col>
                        </b-row>
                    </b-card>

                </template>
                <template #custom-foot>
                    <b-tr class="font-weight-bold">
                        <b-td colspan="5" class="text-right"></b-td>
                        <b-td class="text-right">
                            {{ programacaoVlTotal ? formatMoeda(programacaoVlTotal) : '' }}
                        </b-td>
                    </b-tr>
                </template>
            </b-table>
            <table-pagination v-if="totalRows > pageSize" :total-rows=totalRows :per-page=pageSize
                @pageChange="pageChange" />
        </b-row>
    </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import BuscaTabela from "@/components/shared/BuscaTabela.vue"
import programacaoService from '@/services/eventos/programacaoService'
import { fieldsAtracaoArtistica, detalhes } from '@/types/eventos/programacao/fields-atracao-artistica'
import { AtracaoArtistica } from '@/types/eventos/programacao/atracao-artistica'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'AbaDetalhesAtracoesArtisticas',
    components: { BuscaTabela, TablePagination },
    props: {
        prog: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaDetalhesAtracoesArtisticas extends mixins(UtilsTS, CompProps) {
    

    //table-related
    fields: TableField[] = [detalhes, ...fieldsAtracaoArtistica]
    itens: AtracaoArtistica[] = []
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false
    filtroTexto = ''
    programacaoVlTotal: number | null = null 

    mounted(): void {
        this.loadData()
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await programacaoService.buscarAtracoes(this.prog.IdProgramacao, this.currentPage, this.pageSize, this.filtroTexto)
            if (response) {
                this.itens = response.atracoes.map(l => {
                    const item = Object.assign(new AtracaoArtistica(), l)
                    item.tratarDadosDaAPI()
                    return item
                })
                this.totalRows = response.totalRows
                this.programacaoVlTotal = response.vlTotal
            } else {
                this.$toast.error('Erro ao consultar as atrações dessa programação.');
            }
        } finally {
            this.tableBusy = false;
        }
    }

    async pageChange(value: number): Promise<void> {
        this.currentPage = value;
        await this.loadData();
    }

    filtrarItens(filtro: string): void {
        this.filtroTexto = filtro
        this.currentPage = 1
        this.loadData()
    }
}
</script>

<style scoped>
div.h7rem {
    height: 7rem;
}

@media screen and (max-width: 768px) {
    div.h7rem {
        height: 10rem;
    }
}
</style>